import { render, staticRenderFns } from "./PartnerModalEdit.vue?vue&type=template&id=2f257320"
import script from "./PartnerModalEdit.vue?vue&type=script&lang=js"
export * from "./PartnerModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports